import { render } from "./WatchList.vue?vue&type=template&id=c6730184&scoped=true"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"

import "./WatchList.vue?vue&type=style&index=0&id=c6730184&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6730184"]])

export default __exports__